jQuery(document).ready(function($) {
    $('.wtoy-slick-slider').slick({
        infinite: true,
        slidesToShow: 5,
        // slidesToScroll: 1,
        dots: false,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 800,
        draggable: true,
        swipe: true,
        speed: 500,
        swipeToSlide: true,
        touchMove: true,
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    dots: false,
                    swipeToSlide: true,
                    touchMove: true,
                }
            }
        ]
    });
});